export const PROJECT_TEMPLATE_REDUCER_KEYS = {
  REDUCER: 'projectTemplates',

  CUSTOM: 'custom',
  PUBLIC: 'public',
  PUBLIC_CATEGORIES: 'publicCategories',
}
